
import { FC, useEffect, useRef } from 'react';
import styles from './WishChartBuildings.module.css';
import { Chart, registerables } from 'chart.js';
import { explanationIds } from '../../common/authentication/models/user';
import { Building } from '../../confi-state';
import { UnitAmount } from '../BuildingConf/models/column';

Chart.register(...registerables);

interface WishChartBuildingsProps {
    buildings: Building[];
}

const WishChartBuildings: FC<WishChartBuildingsProps> = ({ buildings }) => {

    const canvasRef = useRef(undefined);
    const chartDrawn = useRef<Chart>(undefined);

    useEffect(() => {
        const getComputedAmountsForType = (type): number => {
            let result = 0;
            const totalAmountOfAllUnits = buildings.map(b => b?.props?.totalAmountOfAllUnits).flat();

            const flatTotalAmounts: UnitAmount[] = [];
            totalAmountOfAllUnits.forEach(t => {
                let found;
                if (flatTotalAmounts.length > 0) {
                    found = flatTotalAmounts.find(f => f.type === t.type);
                }
                if (found) {
                    found.amount += t.amount;
                } else {
                    flatTotalAmounts.push({ ...t });
                }
            })
            if (flatTotalAmounts) {
                const findType = flatTotalAmounts.find(u => u.type === type);
                if (findType && findType.amount) {
                    result = Math.round(findType.amount);
                }
            }
            return result;
        }

        if (canvasRef && buildings.length) {
            const flatUnitWishList = []
            const unitWishList = buildings.map(b => b?.props?.unitWishList).flat();
            unitWishList.forEach(t => {
                let found;
                if (flatUnitWishList.length > 0) {
                    found = flatUnitWishList.find(f => f.type === t.type);
                }
                if (!found) {
                    flatUnitWishList.push({ ...t });
                }
            })

            const resultingData = flatUnitWishList.map(u => getComputedAmountsForType(u.type));

            const labels = flatUnitWishList.map(u => { return u.type });
            const types = flatUnitWishList.map(u => u.type);
            if (canvasRef.current) {
                const data = {
                    labels,
                    datasets: [
                        {
                            label: 'Resultaat',
                            data: resultingData,
                            backgroundColor: types.map(t => {
                                let color = 'rgba(255, 255, 255, 1)';
                                switch (t) {
                                    case 'C-XS':
                                        color = 'rgba(251, 169, 25, 1)';
                                        break;
                                    case 'C-S':
                                        color = 'rgba(242, 237, 116, 1)';
                                        break;
                                    case 'C-M':
                                        color = 'rgba(113, 185, 216, 1)';
                                        break;
                                    case 'C-L':
                                        color = 'rgba(230, 111, 106, 1)';
                                        break;
                                    case 'C-XL':
                                        color = 'rgba(136, 129, 189, 1)';
                                        break;
                                    case 'G-S':
                                        color = 'rgba(242, 237, 116, 1)';
                                        break;
                                    case 'G-M':
                                        color = 'rgba(113, 185, 216, 1)';
                                        break;
                                    case 'G-L':
                                        color = 'rgba(230, 111, 106, 1)';
                                        break;
                                    case 'G-XL':
                                        color = 'rgba(169, 90, 113, 1)';
                                        break;
                                    case 'H-S':
                                        color = 'rgba(248, 193, 58, 1)';
                                        break;
                                    case 'H-M':
                                        color = 'rgba(136, 129, 189, 1)';
                                        break;
                                    case 'H-L':
                                        color = 'rgba(68, 116, 141, 1)';
                                        break;
                                    default:
                                        break;
                                }
                                return color;
                            }).filter(s => s !== undefined),
                            barPercentage: 0.5
                        },
                    ]
                };
                if (chartDrawn && chartDrawn.current) {
                    chartDrawn.current.data = data;
                    chartDrawn.current.update();
                } else {
                    chartDrawn.current = (new Chart(canvasRef.current as any, {
                        type: 'bar',
                        data,
                        options: {
                            responsive: true,

                            animation: {
                                duration: 0
                            },
                            scales: {
                                y: {
                                    beginAtZero: true,
                                },

                            },
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (item) => `${item.formattedValue} woningen`,
                                    },
                                }
                            }
                        }
                    })
                    );
                }
            }
        }
    }, [canvasRef, buildings, chartDrawn])

    return (
        <div data-explanation-id={explanationIds.buildingDetails} className={styles.WishChart} data-testid="WishChart">
            <canvas ref={canvasRef} id={'svgIdAllBuildings'} width="400" height="300"></canvas>
        </div>
    )
};

export default WishChartBuildings;
